/*
 * DeleteMoal.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 11 2023 mys Company
 */

import { useEffect, useState } from 'react'
import { localization } from '../../config/localize/localizable'
import BaseModal from './BaseModal'

const DeleteModal = ({ title, visible, complete }) => {
    //
    // MARK: METHODS
    const [visibleModal, setVisibleModal] = useState(visible)

    const loaded = useEffect(() => {
        setVisibleModal(visible)
    }, [visible])

    const handleClick = () => {
        if (complete) complete(true)
        setVisibleModal(true)
    }

    const handleCancel = () => {
        complete(false)
        setVisibleModal(true)
    }
    return (
        <div
            id=""
            className={`fixed top-0 right-0 bottom-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex justify-center  ${visibleModal ? 'hidden' : ''}`}
            onClick={(e) => {
                //setVisibleModal(true)
            }}
        >
            <div className="w-2/3 md:w-1/3  h-64 bg-white  rounded my-32">
                <div className=" border-b mb-4 grid grid-cols-7 bg-black bg-opacity-70 rounded-tl rounded-tr">
                    <span className="h-8 inline-block col-span-6 pt-1 pr-2 text-white">{title}</span>
                    <div className="w-full col-span-1 text-left pt-1 pl-2" dir="ltr">
                        <div className="w-5 h-5  text-center rounded-full text-white select-none">x</div>
                    </div>
                </div>
                <div className="p-2 pt-4 ">{localization.MSG_doyouwanttodeleterecord}</div>

                <div className="mt-24" dir="ltr">
                    <button className="w-1/4 bg-red-600 p-2 text-white rounded m-2" onClick={handleClick}>
                        {localization.delete}
                    </button>
                    <button className="w-1/4 bg-gray-600 p-2 text-white rounded" onClick={handleCancel}>
                        {localization.cancel}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteModal
